module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-italic.5cbf63dd.eot";